import React from "react";
import { FaSun, FaMoon } from "react-icons/fa";
import ThemeContext from "./context";
import logo from "./assets/logo.png"
import {fontstyle2} from "./utils/fonts"

const Header = () =>{
    const {theme,setTheme} = React.useContext(ThemeContext);

    return(
        <div className="p-5 w-full flex items-center justify-between">
            <img src={logo} alt="logo" className="w-48" />
            <div
      onClick={() => {
        setTheme(theme === "dark" ? "light" : "dark");
        localStorage.setItem("theme", theme === "dark" ? "light" : "dark");
      }}
    >
      {theme === "light" ? (
        <div className="text-xl text-[#101426] cursor-pointer flex items-center gap-2">
          <span className="text-base hidden sm:block text-black" style={fontstyle2}>
            Light mode
          </span>
          <FaSun />
        </div>
      ) : (
        <div className="text-xl text-white cursor-pointer flex items-center gap-2">
          <span className="text-base hidden sm:block" style={fontstyle2}>
            Dark mode
          </span>
          <FaMoon />
        </div>
      )}
    </div>
        </div>
    )
}

export default Header;